// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"new-160w-solar-panel_productcontent__ivwgZ"};